/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { deleteData } from "../../../hooks/delete";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";
import GalleryContent from "./GalleryContent";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { motion } from "framer-motion";

const GalleryContentPage = () => {
    const { galleriesApi } = apiPath;
    const { aboutUsGalleriesAdd, aboutUsGalleries } = RoutePath;
    const { clientGallery } = clientSideUrl;
    const [galleriesContentData, galleriesLoading] = useFetch(galleriesApi);
    const [galleryOrder, setGalleryOrder] = useState([]);
    const [updatedGalleryList, setUpdatedGalleryList] = useState(null);

    useEffect(() => {
        if (Array.isArray(galleriesContentData)) {
            setGalleryOrder(galleriesContentData);
        }
    }, [galleriesContentData]);

    async function handleSingleDelete(id) {
        const swalResponse = await Swal.fire({
            title: "Are you sure you want to delete this?",
            showCancelButton: true,
            confirmButtonText: "Delete",
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                return await deleteData(galleriesApi, id);
            },
            allowOutsideClick: () => !Swal.isLoading(),
        });
        return swalResponse?.value?._id?.length > 0;
    }
    const onSortEnd = ({ oldIndex, newIndex }) => {
        const newOrder = arrayMoveImmutable(galleryOrder, oldIndex, newIndex);
        setGalleryOrder(newOrder);
        const payload = newOrder.map((item, idx) => ({
            _id: item._id,
            galleryId: idx + 1,
        }));
        setUpdatedGalleryList(payload)

    };

    const updateNewListToDB = () => {
        updateData(`reorder/galleries`, updatedGalleryList);
        setTimeout(() => {
            setUpdatedGalleryList(null)
            window.location.href = "/" + aboutUsGalleries;
        }, 800);
    }


    // Wrapping Content

    const DragHandle = SortableHandle(() => (
        <span className="cursor-move text-gray-400">⠿</span>
    ));

    const SortableItem = SortableElement(({ item, index, onDelete }) => (
        <GalleryContent
            key={item._id}
            galleriesContentData={item}
            handleSingleDelete={onDelete}
            dragHandle={<DragHandle />}
        />
    ))

    const SortableList = SortableContainer(({ items, onDelete }) => (
        <div>
            {
                items.map((item, index) => (
                    <SortableItem
                        key={`item-${item._id}`}
                        index={index}
                        item={item}
                        onDelete={onDelete}
                    />
                ))
            }
        </div>
    ))

    if (galleriesLoading) {
        return <Loading />;
    }

    return (
        <div className="relative">
            <div className="mb-4 w-full text-right font-semibold text-sm">
                <div className="flex justify-end items-center gap-4">
                    {updatedGalleryList && (
                        <>
                            <motion.button
                                onClick={updateNewListToDB}
                                type="button"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5, ease: "easeInOut" }}
                                className="cursor-pointer btn btnW7ide border-2 text-[#DB0029] font-bold border-[#DB0029] hover:text-white hover:border-[#DB0029] hover:bg-[#DB0029] hover:shadow-md px-3 lg:px-5 py-1.5 rounded-xl transition duration-150"
                            >
                                Save Changes
                            </motion.button>

                            {/* Divider */}
                            <div className="h-5 w-px bg-gray-300" />
                        </>
                    )}


                    <Link
                        className="text-black hover:text-[#DB0029] flex items-center"
                        to={clientGallery}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Visit page
                        <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="inline w-4 h-4 ml-1 align-text-top"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                                />
                            </svg>
                        </span>
                    </Link>
                </div>

            </div>
            <div className=" mt-5">
                {/* {galleriesContentData.length > 0 &&
                    galleriesContentData.map((item) => (
                        <GalleryContent
                            key={item._id}
                            galleriesContentData={item}
                            galleriesLoading={galleriesLoading}
                            handleSingleDelete={handleSingleDelete}
                        />
                    ))} */}

                <SortableList
                    items={galleryOrder}
                    onDelete={handleSingleDelete}
                    onSortEnd={onSortEnd}
                    axis='y'
                    useDragHandle
                />

            </div>

            <div className="fixed bottom-10 right-7 md:right-14">
                <Link to={`/${aboutUsGalleriesAdd}`}>
                    <button
                        title="Add new gallery item"
                        className="p-4 md:p-5 bg-[#DB0029] text-white border-2 border-transparent rounded-full hover:bg-white hover:border-[#DB0029] hover:text-[#DB0029] transition-all duration-100"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5 md:w-8 md:h-8"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 4.5v15m7.5-7.5h-15"
                            />
                        </svg>
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default GalleryContentPage;
